import Isotope from 'isotope-layout';
const $win = $(window)

$win.on('load', function() {
  if ($('.js-grid-row').length && $('.js-grid-row-item').length) {
    const grid = new Isotope('.js-grid-row', {
      itemSelector: '.js-grid-row-item',
      layoutMode: 'fitRows'
    });

    function hasClass(element, className) {
      do {
        if (element.classList && element.classList.contains(className)) {
          return true;
        }
        element = element.parentNode;
      } while (element);
      return false;
    }

    // bind filter button click
    var filtersElem = document.querySelector('.js-filters-button-group');
    filtersElem.addEventListener( 'click', function( event ) {
      // only work with buttons
      if(event.target.tagName.toLowerCase() === 'button') {
        var filterValue = event.target.getAttribute('data-js-grid-filter');
        // use matching filter function
        grid.arrange({ filter: filterValue });
        const className = 'is-expanded'
        let element = event.target

        do {
          if (element.classList && element.classList.contains(className)) {
            element.classList.remove(className)
            return false;
          }
          element = element.parentNode;
        } while (element);
        return false;
      }
    });

    // change is-current class on buttons
    var buttonGroups = document.querySelectorAll('.js-button-group');
    for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
      var buttonGroup = buttonGroups[i];
      radioButtonGroup( buttonGroup );
    }

    function radioButtonGroup( buttonGroup ) {
      buttonGroup.addEventListener( 'click', function( event ) {
        if(event.target.tagName.toLowerCase() === 'button') {
          const filterTextElem = document.querySelector('.js-filter-text-change')
          // only work with buttons
          buttonGroup.querySelector('.is-current').classList.remove('is-current');
          event.target.classList.add('is-current');

          if (filterTextElem) {
            const textElement = buttonGroup.querySelector('.is-current').textContent
            filterTextElem.textContent = textElement
          }
        }
      });
    }
  }
})
